var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.275024 1.30001L1.1112 0.475006L5.49998 4.86379L9.88876 0.475006L10.7249 1.30001L5.49994 6.52501L0.275024 1.30001Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDExIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjI3NTAyNCAxLjMwMDAxTDEuMTExMiAwLjQ3NTAwNkw1LjQ5OTk4IDQuODYzNzlMOS44ODg3NiAwLjQ3NTAwNkwxMC43MjQ5IDEuMzAwMDFMNS40OTk5NCA2LjUyNTAxTDAuMjc1MDI0IDEuMzAwMDFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };